import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const VerticalStoriesListBase = styled.div`
  margin-bottom: 2rem;

  h6 {
    margin-bottom: 0;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid ${theme.colors.darkBlues[10]};
  }
`;

export const MetaText = styled.div`
  font-size: ${theme.fontSizes[0]};
  line-height: ${theme.leading.tight};
  color: ${theme.colors.darkBlues[50]};

  & i {
    color: ${theme.colors.darkBlues[75]};
  }
`;

export const Story = styled.div`
  padding: 1rem 0;
  border-bottom: 1px solid ${theme.colors.darkBlues[10]};
`;

export const Title = styled.h5`
  margin-top: 0;
`;

export const TitleLink = styled.a`
  display: block;
  color: ${theme.colors.darkBlues[100]};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const MetaInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;
